import type { Source } from "@tandemdiabetes/sugarmate-api-react-client"
import { useRemoveSource } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"

import { useSources } from "./useSources"
import { noticeError } from "src/utils"

export function useDeleteSource() {
  const removeSource = useRemoveSource()
  const { mutate } = useSources()

  const deleteSource = useMemo(
    () => !removeSource ? undefined : async (sourceId: Source["id"]) => {
      try {
        const response = await removeSource(sourceId)
        void mutate()
        return response
      } catch (e) {
        noticeError(
          e,
          "DeleteSource",
          { sourceId },
        )

        throw e
      }
    },
    [
      removeSource,
      mutate,
    ],
  )

  return deleteSource
}
